<template>
    <div class="t-web-integration">
        <slot v-if="isInfoView"/>
        <OSidebarOtg
            v-else
            :class="sidebarClass"
        >
            <slot></slot>
        </OSidebarOtg>
        <OManageDestinationPanel v-if="isPathView"/>
        <ODMap class="web-integration-map">
            <template #extras>
                <OMapObjectInfoOtg v-if="isItemInfo"/>
            </template>
        </ODMap>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { isMobileOnly } from 'mobile-device-detect';

import OSidebarOtg from '../../organisms/o-sidebar-otg';
import ODMap from '../../unique-organisms/o-d-map/o-d-map';
import OMapObjectInfoOtg from '../../organisms/o-map-object-info-otg';
import OManageDestinationPanel from '../../organisms/o-manage-destination-panel-otg';

import { WEB_INTEGRATION } from "../../../utils/constants/route-constants";

export default {
    name: 'TWebIntegration',
    components: {
        ODMap,
        OSidebarOtg,
        OMapObjectInfoOtg,
        OManageDestinationPanel
    },
    props: {
        isAppLoaded: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        isInfoView() {
            return (this.$route.name === WEB_INTEGRATION.STORE.INFO.NAME || this.$route.name === WEB_INTEGRATION.CATALOGUE.START.NAME) && this.isAppLoaded;
        },
        isPathView() {
            return (this.$route.name === WEB_INTEGRATION.CATALOGUE.PATH.NAME || this.$route.name === WEB_INTEGRATION.STORE.PATH.NAME)
                && isMobileOnly
                && this.isAppLoaded;
        },
        isItemInfo() {
            return (this.$route.query.t || this.$route.query.mTo) 
                && !this.componentParams.is_hide_item_info
                && !this.mapObjectInfoExcludeRoutes?.includes(this.$route.name)
            // return [WEB_INTEGRATION.STORE.SETTINGS.NAME, WEB_INTEGRATION.STORE.PATH.NAME, WEB_INTEGRATION.CATALOGUE.SETTINGS.NAME, WEB_INTEGRATION.CATALOGUE.PATH.NAME].includes(this.$route.name);
        },
        sidebarClass() {
            return this.$route.name.split('.').slice(-1);
        },
        mapObjectInfoExcludeRoutes(){
            return this.componentParams.map_object_info_exclude_routes || []
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.TWebIntegration.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.TWebIntegration.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        }
    },
    mounted() {
        this.initListeners();
        this.setDynamicVh();
    },
    methods: {
        initListeners() {
            window.addEventListener('resize', this.setDynamicVh);
        },
        setDynamicVh() {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            window.scroll(0, 0);
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
